<div class="agpr-tagsPicker">
    <div
        *ngIf="showHeader"
        class="agpr-tagsPicker-header">
        <span class="agpr-tagsPicker-headerTitle">
            {{ 'Tags.tags' | localize }}
        </span>

        <span
            role="img"
            class="agpr-infoIconStyle fa-regular fa-circle-info"
            agprTooltip="Tags.info"
        ></span>
    </div>
    <div
        class="agpr-tagsPicker-autocomplete"
        [ngClass]="{'agpr-tagsPicker-autocomplete--withChips': tagChips && tagChips.length}"
    >
        <agpr-autocomplete
            #autocomplete
            [id]="id + '_autoComplete'"
            labelField="name"
            [placeholder]="placeholder"
            [dropdown]="true"
            [isInTable]="isInTable"
            [(ngModel)]="selectedTag"
            (itemSelected)="selectTag($event)"
            [ngClass]="{'agpr-tagsPicker-autocomplete--noTagsSelected': !value?.length }"
            [customOptions]="tagsAutocompleteOptions"
            [suggestions]="tagList$"
            [multiSelection]="false"
            [ariaLabel]="'Tags.inputTooltip'"
        ></agpr-autocomplete>
        <agpr-button
            *ngIf="showManageTags"
            [id]="id + '_manageTagsButton'"
            [style]="buttonTypes.block"
            icon='fa-regular fa-duotone fa-gear'
            class='agpr-tagsPicker-manageButton'
            [ngClass]="{
                'agpr-tagsPicker-manageButton--noTagsSelected': !value?.length,
                'agpr-tagsPicker-manageButton--social': style === agprComponentStyleEnum.social
            }"
            [initiallyFocusable]="!isInTable"
            tooltip="Tags.manageDialog.header"
            (click)="manageButtonClicked()"
            tooltipPosition="top"
        ></agpr-button>
    </div>

    <div
        *ngIf="tagChips && tagChips.length"
        class="agpr-tagsPicker-chips"
    >
        <agpr-chip-container
            [id]="id + '_chipContainer'"
            [chips]="tagChips"
            (removeChip)="tagRemoved($event)"
            [style]="style"
            [isInTable]="isInTable"
        ></agpr-chip-container>
    </div>

    <agpr-form-message
        *ngIf="maxTagsSelected && errorMessage">
        {{ errorMessage | localize }}
    </agpr-form-message>
</div>
